import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

// Navigation
import HeaderNavigation from './HeaderNavigation';


class Header extends Component {
    render () {
        return (
            <header className="header">
            	<div className="container">
	                <NavLink className="header__logo" to="/"><img src="https://rascalsthemes.com/images/logo.svg" alt="Rascals Themes" /></NavLink>
	                <HeaderNavigation />
                </div>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/containers/Header/Header.js